import React, {useContext} from 'react';
import {useAppStore} from "../../../../../GlobalStore/GlobalStore.ts";
import {MessageContext} from "../../Message.tsx";
import {canSeeVideo} from "../../../../../Utils/misc/modelInsightUtils.ts";

interface VideoProps {
    item: {
        fileContent: string;
        fileName: string;
        previewUrl?: string;
    };
}

const Video: React.FC<VideoProps> = ({ item }) => {
    const { isPreview } = useContext(MessageContext);
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    const handleVideoClick = (videoSource: string) => {
        setDynamicStateObj({
            visiblePopup: "enlargedContent",
            enlargedContent: {
                type: "video",
                content: videoSource,
                previewUrl: item.previewUrl
            },
        });
    };
    const canSee = canSeeVideo(settingsObj.model);

    return (
        <div className="flex-none bg-neutral-200 dark:bg-neutral-900">
            <button
                className="cursor-pointer relative"
                onClick={() => handleVideoClick(item.fileContent)}
            >
                {item.previewUrl ? (
                    <img
                        className="my-3 mx-3 p-1 w-52 h-52 object-contain bg-black cursor-pointer rounded-lg"
                        src={item.previewUrl}
                        alt="Video Thumbnail"
                    />
                ) : (
                    <video
                        className="my-3 mx-3 p-1 w-52 h-52 object-contain bg-black cursor-pointer rounded-lg"
                        src={item.fileContent.startsWith('data:') || item.fileContent.startsWith('http')
                            ? item.fileContent
                            : `data:video/mp4;base64,${item.fileContent}`}
                    />
                )}
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 bg-black bg-opacity-50 rounded-full flex items-center justify-center">
                        <div className="w-0 h-0 border-t-8 border-t-transparent border-l-[16px] border-l-white border-b-8 border-b-transparent ml-1"></div>
                    </div>
                </div>
                {(!isPreview && !canSee) && (
                    <>
                        <div className="absolute inset-0 bg-black bg-opacity-50" />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-black bg-opacity-75 text-white px-4 py-1 rounded text-sm">
                                Not supported by model
                            </div>
                        </div>
                    </>
                )}
            </button>
        </div>
    );
};

export default Video;